"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dragStateReducer = void 0;
var utils_1 = require("../../../utils");
var dragStateReducer = function (state, value) {
    var startPos = state.start;
    var endPos = value.pos;
    switch (value.op) {
        case 'leave':
            return state.withMutations(function (st) {
                return st.set('dragging', false).set('vector', (0, utils_1.IVector2d)());
            });
        case 'start':
            return state.withMutations(function (st) {
                return st
                    .set('dragging', true)
                    .set('start', value.pos)
                    .set('vector', (0, utils_1.IVector2d)());
            });
        case 'end':
            return state.withMutations(function (st) {
                return st
                    .set('dragging', false)
                    .set('end', endPos)
                    .set('vector', (0, utils_1.IVector2d)({
                    x: endPos.x - startPos.x,
                    y: endPos.y - startPos.y
                }));
            });
        case 'current':
            return state.withMutations(function (st) {
                return st.set('vector', (0, utils_1.IVector2d)({
                    x: endPos.x - startPos.x,
                    y: endPos.y - startPos.y
                }));
            });
    }
};
exports.dragStateReducer = dragStateReducer;
